import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import './style.scss'

import CountTag from '../CountTag';
import ActivityTag from '../ActivityTag';
import PBIcon from '../PBIcon';
import ActivityPickerModal from '../ActivityPickerModal';

import { globalHelper } from '@progressivebeef/shared/src/helpers';
import ActivityHelper from '@progressivebeef/shared/src/helpers/ActivitiesHelper';

import { getLocale } from '@progressivebeef/shared/src/services/storageService/GlobalData';
import localization from '@progressivebeef/shared/src/localization/i18n';

import {
  setCurrentActivity,
  setCurrentInstance,
} from '@progressivebeef/shared/src/store/actions/activities';
import {
  userRoles,
  ACTIVITY_PERMISSIONS,
  ACTIVITY_FREQUENCY,
  DATE_FORMATS,
} from '@progressivebeef/shared/src/constants/AppConstants';
import RouteConstants from '@progressivebeef/shared/src/constants/RouteConstants';
import AssetConstants from '@progressivebeef/shared/src/constants/AssetConstants';

class ActivitySubmissionCard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
    };
  }

  onActivityCardPress = (currentActivity) => {
    const { user, setCurrentActivityRequest, tabType, date } = this.props;

    setCurrentActivityRequest(currentActivity);

    if (Number(user.userRoleId) === userRoles.WORKER) {
      if (currentActivity.instance_based) {
        this.props.history.push(RouteConstants.ACTIVITY_INSTANCE, {
          currentActivity,
          backdated: tabType,
          date: date,
        });
      } else {
        this.props.history.push(RouteConstants.ACTIVITY_SUBMISSIONS, {
          currentActivity,
          backdated: tabType,
          date: date,
        });
      }
    } else {
      if (
        /**
         * if activity permission_key is assigned worker, and activity is instance based and can not be scheduled
         * then push directly instance screen
         */
        currentActivity.instance_based &&
        currentActivity.permission_key ===
        ACTIVITY_PERMISSIONS.ASSIGNED_WORKER &&
        currentActivity.frequency_key === ACTIVITY_FREQUENCY.REQUIRED
      ) {
        this.props.history.push(RouteConstants.ACTIVITY_INSTANCE, {
          currentActivity,
          backdated: tabType,
          date: date,
        });
      } else {
        this.setState({ modalVisible: true });
      }
    }
  };

  onPickerPress = () => {
    this.setState({ modalVisible: false });
  };

  render() {
    let {
      item,
      history,
      setCurrentActivityRequest,
      setCurrentInstanceRequest,
      user,
      tabType,
      date,
    } = this.props;
    let { modalVisible } = this.state;
    const title = item.locale
      ? item.locale[getLocale() === 'en' ? 1 : 2].title
      : localization[getLocale()].TITLE;
    return (
      <>
        <ActivityPickerModal
          item={item}
          user={user}
          backdated={tabType}
          date={date}
          history={history}
          modalVisible={modalVisible}
          onPressEvent={this.onPickerPress}
          setCurrentActivity={setCurrentActivityRequest}
          setCurrentInstance={setCurrentInstanceRequest}
        />
        <div className="activity-submission-main-box" onClick={() => this.onActivityCardPress(item)}>

          <div>
            <div className="activity-submission-log-flex-col">
              <div className="activity-submission-log-box">
                <img
                  alt="description"
                  src={ActivityHelper.getTypeIcon(item)}
                />
                <div className="title">{item.activity_number}</div>
              </div>
              <div className="activity-submission-clock-box">
                <img alt="description" src={AssetConstants.circleClock} />
                <div className="title">
                  {item.activityBackDatedSubmissions[tabType]
                    ? item.activityBackDatedSubmissions[tabType]
                      .backdatedSubmissionCount
                    : 0}
                </div>
              </div>

            </div>
            <div className="activity-submission-tile-box">{title}</div>
            <div className="activity-submission-list-of-detail">
              {item.instance_submission &&
                item.instance_submission.denominator && (
                  <CountTag
                    count={item.instance_submission.numerator}
                    totalCount={item.instance_submission.denominator}
                  />
                )}
              <div className="activity-submission-user-box">
                <PBIcon name={'user'} />
                <div className="no">{item.users ? item.users.length : 0}</div>
              </div>
              {globalHelper.renderIf(item.last_submitted_date)(
                <div className="activity-submission-date-box">
                  <div className="icon"><PBIcon name={'calendar-check'} /></div>
                  <div className="date">
                    {moment(item.last_submitted_date).format(
                      DATE_FORMATS.MM_DD_YY
                    )}
                  </div>
                </div>
              )}
              {item.reminder_date ? (
                <div className="activity-submission-date-box stopwatch-edit-date">
                  <div className="icon"><PBIcon name={'stopwatch'} /></div>
                  <div className="date">
                    {moment(item.reminder_date).format(DATE_FORMATS.MM_DD_YY)}
                  </div>
                </div>
              ) : (
                  globalHelper.renderIf(item.due_date)(
                    <div className="activity-submission-date-box stopwatch-edit-date">
                      <div className="icon"><PBIcon name={'calendar-edit'} /></div>
                      <div className="date">
                        {moment(item.due_date).format(DATE_FORMATS.MM_DD_YY)}
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>


          {item.activity_tags && (
            <div>
              <ActivityTag
                history={history}
                tags={item.activity_tags}
              // customStyle={styles.tagStyle}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state.authentication;

  return {
    user: user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentActivityRequest: (payload) =>
      dispatch(setCurrentActivity(payload)),
    setCurrentInstanceRequest: (payload) =>
      dispatch(setCurrentInstance(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivitySubmissionCard);
